<template>
<div>
  <figure class="avatar avatar-sm" :data-initial="inits">
    <img v-if="avatar" :src="avatar">
  </figure>
</div>
</template>

<script>
import axios from 'axios'
import { bus } from '@/components/bus.js'

export default {
  name: 'avatar',
  props: ['user'],
  data () {
    return {
      avatar: null,
      inits: '?'
    }
  },
  created () {
    let p = this.user.profile

    // Load an image if available
    if (p.avatar) {
      this.load()
    }

    // Set the initials
    if (p.corporate) {
      let bname = p.business.toUpperCase().split(' ')
      if (bname.length > 1) {
        this.inits = bname[0][0] + bname[1][0]
      } else {
        this.inits = bname[0][0] + (bname[0][1] || '')
      }
    } else if (p.firstname && p.lastname) {
      this.inits = p.firstname[0] + p.lastname[0]
    }

    bus.$on('new_avatar', (userId, data) => {
      if (this.user._id === userId) {
        this.avatar = data
      }
    })
    bus.$on('del_avatar', (userId) => {
      if (this.user._id === userId) {
        this.avatar = null
      }
    })
  },
  methods: {
    load () {
      axios.get('/api/users/avatars/get/' + this.user.profile.avatar)
      .then(res => {
        if (res.status === 200) {
          this.avatar = res.data.data
        }
      })
      .catch(e => { console.log(e.response.data) })
    }
  }
}
</script>

<style scoped>
.avatar {
    background: #136efb
  }
</style>



// WEBPACK FOOTER //
// avatar.vue?1aee4cf4